import type {ActionSpec, ActionStruct} from '@cohort/shared/schema/apps/app';
import z from 'zod';

export const InviteToChannelInputSchema = z.object({
  discordUserId: z.string(),
  roleId: z.string(),
});
export type InviteToChannelInput = z.infer<typeof InviteToChannelInputSchema>;

export const InviteToChannelOutputSchema = z.object({
  inviteUrl: z.string().url(),
  guildName: z.string(),
});
export type InviteToChannelOutput = z.infer<typeof InviteToChannelOutputSchema>;

export type InviteToChannelActionStruct = ActionStruct<
  'invite-to-channel',
  InviteToChannelInput,
  InviteToChannelOutput
>;
export const InviteToChannelActionSpec: ActionSpec<InviteToChannelActionStruct> = {
  id: 'invite-to-channel',
  inputSchema: InviteToChannelInputSchema,
  outputSchema: InviteToChannelOutputSchema,
};
